import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'moment';

import Spacer from '../../components/common/spacer/Spacer';
import Pagination from '../../components/common/pagination/Pagination';
import Loader from '../../components/common/loader/Loader';
import ErrorScreen from '../../components/derived/error/ErrorScreen';
import ProductCard from '../../app-utils/card/ProductCard';

import Api from '../../../utils/api';

require('./style.scss');

export default class Offers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      offerCount: 0,
      offers: null,
    };
  }

  componentDidMount() {
    const { profile, params } = this.props;
    this.fetchOffers(profile.code, params.pageId || 1);
  }

  componentWillReceiveProps(nextProps) {
    const pageId = nextProps.params.pageId;
    if (pageId) {
      this.fetchOffers(nextProps.profile.code, pageId);
    }
  }

  fetchOffers(code, page) {
    this.setState({ offers: null });

    if (!code) {
      return;
    }

    Api.offers(code, page).then(response => this.setState({
      offerCount: response.count,
      offers: response.results,
    }));
  }

  renderProducts(products) {
    const cards = [];

    for (let index = 0; index < _.size(products); index += 1) {
      if (products[index] !== null) { cards.push(Offers.renderProductCard(products[index])); }
    }

    return (
      <div id="products">
        <div className="store-offer-product-cards">{cards}</div>
        <Spacer size={2} />
        <Pagination
          totalPages={_.ceil((this.state.offerCount || 1) / 5)}
          currentPage={parseInt(this.props.params.pageId, 10) || 1}
          urlPrefix={`/${this.props.params.partnerSlug}/offers`}
        />
      </div>
    );
  }

  render() {
    let products = null;
    const { profile } = this.props;

    if (this.state.offers === null) {
      products = <Loader open />;
    } else if (_.size(this.state.offers) > 0) {
      products = (
        <div className="store-offer-products">
          {this.renderProducts(Offers.getOfferList(this.state.offers))}
        </div>);
    } else {
      products = (
        <ErrorScreen
          media={<img role="presentation" src="/static/images/no-Discount.png" />}
          title="Offers coming soon"
          helpText={`Stay updated with ${profile.store_name}<br />` +
                    'through m.Paani Shop Smart App'}
        />
      );
    }

    return (
      <main id="offers-body">
        <Spacer size={2} />
        <div id="content">
          {products}
        </div>
        <Spacer size={2} />
      </main>);
  }
}

Offers.getOfferList = (offers) => {
  const randomIndex = _.random(1, _.size(offers) - 1);
  return _.concat(_.slice(offers, 0, randomIndex), null, _.slice(offers, randomIndex));
};

Offers.renderProductCard = product =>
  <ProductCard
    key={product.id}
    media={
      <img
        alt={`${product.title}`}
        src={product.offer_image || '/static/images/product_default.png'}
      />}
    title={product.title}
    offer={product.offer}
    originalPrice={_.toInteger(product.mrp) || null}
    price={_.toInteger(product.discounted_price)}
    expiry={Moment(product.valid_to)}
  />;

Offers.renderProductRow = (product, index) =>
  <div key={index} >
    {Offers.renderProductCard(product)}
  </div>;

Offers.propTypes = {
  params: PropTypes.shape({
    pageId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    partnerSlug: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./app/pages/offers/Offers.jsx